import { EventEmitter } from 'events';

var ee = new EventEmitter();


export function openLoginModal (returnUrl?) {
  if (returnUrl) {
    console.log('Return url defined: ', returnUrl);
    ee.emit('openLoginModal', returnUrl);
  }
  else ee.emit('openLoginModal');
}

export default ee;
